import React from "react";

const NoResults = ({ text, className }) => (
    <h3 role="status" aria-live="polite" className={`title-3 text-gray ${className}`}>
        {text}
    </h3>
);

export default NoResults;
